import FileSaver from 'file-saver';

const downloadFile = (param) => {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', param.url);
    xhr.responseType = 'arraybuffer';

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        // let lastDot = file.originalFileName.lastIndexOf('.');
        // let fileExt = file.originalFileName.substring(lastDot, file.originalFileName.length).toLowerCase();
        // 나중에 type 분기 필요 시 사용(확장자)

        let blob = new Blob([xhr.response]);

        // IOS Chrome 분기처리
        if (navigator.userAgent.match('CriOS')) {
          let reader = new FileReader();
          reader.onload = function (e) {
            window.location.href = reader.result;
          };
          reader.readAsDataURL(blob);
        } else {
          FileSaver.saveAs(blob, param.fileOriginalName);
        }
        resolve(xhr.status);
      } else if (xhr.readyState === 4 && xhr.status !== 200) {
        resolve(xhr.status);
      }
    };
    xhr.send();
  });
};

export default {
  downloadFile,
};
